<template>
  <v-container grid-list-md class="pa-0">
    <v-row dense v-if="isSetItem">
      <v-col cols="12" class="text-right caption px-4 pt-4">入金期日: {{ printDue }}&nbsp;発行日: {{ printCharged }}</v-col>
      <v-col cols="12">
        <v-list>
          <v-list-item class="secondary">
            <v-row dense>
              <v-col cols="6" class="text-left white--text">請求内容</v-col>
              <v-col cols="6" class="text-right white--text">計: {{ printTotal }}</v-col>
            </v-row>
          </v-list-item>
          <template v-for="item in getChildren">
            <v-list-item :key="item.id">
              <v-col cols="6" class="text-left">{{ item.label }}</v-col>
              <v-col cols="6" class="text-right">{{ item.sum }}</v-col>
            </v-list-item>
            <v-divider :key="`div_${item.id}`"></v-divider>
          </template>
          <v-divider></v-divider>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'DetailPane',
  props: [
    'item'
  ],
  computed: {
    isSetItem () {
      return this.$props.item
    },
    printDue () {
      return this.$props.item.date ? this.$moment(this.$props.item.date).format('YYYY/MM/DD') : ''
    },
    printCharged () {
      return (this.$props.item.children && this.$props.item.children.length) ? this.$moment(this.$props.item.children[0].date).format('YYYY/MM/DD') : ''
    },
    printTotal () {
      return this.$props.item.sum ? `¥${this.$props.item.sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '¥0'
    },
    getChildren () {
      return this.$props.item.children ? this.$props.item.children.map(it => {
        return {
          id: it.id,
          label: (it.label && this.$mango.charge.types[it.label]) ? this.$mango.charge.types[it.label] : it.label,
          sum: it.sum ? `¥${it.sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '¥0'
        }
      }) : []
    }
  }
}
</script>

<style>

</style>
